import React from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from './Grid';
import Label from './Label';
import cx from 'classnames';
import { isNullOrUndefined } from '../../util/objects';

const styles = ({ spacing, palette, transitions, breakpoints, typography }) => ({
    inlineHeaderRightAlignChildren: {
        display: 'flex',
        // marginBottom: -14,
        lineHeight: 2.25,
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        '& > :first-child': {
            flex: '1 1 auto',
            alignSelf: 'center'
        },
        '& > :not(:first-child)': {
            marginLeft: '5px'
        }
    },

    inlineFieldRightAlignChildren: {
        display: 'flex',
        lineHeight: 2.25,
        justifyContent: 'flex-end',
        flexWrap: 'wrap',
        width: '100%',
        '& > :first-child': {
            flex: '1 1 auto',
            lineHeight: 'inherit'
        },
        '& > :not(:first-child)': {
            marginLeft: '5px',
            lineHeight: 'inherit'
        }
    },

    inlineHeader: {
        display: 'inline-flex',
        flexWrap: 'wrap',
        lineHeight: 2.25,
        alignItems: 'baseline',
        gap: `0 ${spacing(2)}`,
        '& > :first-child': {
            flex: '0 0 auto',
            lineHeight: 'inherit',
            alignSelf: 'center',
            minWidth: 90
        }
    },

    inlineField: {
        display: 'flex',
        flexWrap: 'nowrap',
        lineHeight: 2.25,
        '& > div': { padding: 0 },
        '& > :first-child': {
            lineHeight: 'inherit',
            '&[role=heading]': {
                alignSelf: 'center',
                minWidth: 90
            }
        },
        '& > :not(:first-child)': {
            marginLeft: 15,
            lineHeight: 'inherit'
        }
    },

    inlineFlex: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        lineHeight: 2.25,
        '& > :not(:first-child)': {
            marginLeft: '15px',
            marginRight: 0,
            lineHeight: 'inherit'
        }
    }
});

//inline grid that contains elements in a left-to-right line
const InlineField = withStyles(styles)(
    ({ classes, children, className, lineHeight, center, wrap, style, ...props }) => {
        const styles = { ...style };
        if (!isNullOrUndefined(lineHeight)) styles.lineHeight = lineHeight;
        if (!!center) styles.alignItems = 'center';
        if (!!wrap) styles.flexWrap = 'wrap';
        return (
            <Grid pc={1} className={cx(classes.inlineField, className, 'inlineField')} style={styles}>
                {children}
            </Grid>
        );
    }
);

//inline grid that contains elements in a left-to-right line
const InlineFieldRightAlignChildren = withStyles(styles)(
    ({ classes, children, className, lineHeight, center, ...props }) => {
        const style = {};
        if (!isNullOrUndefined(lineHeight)) style.lineHeight = lineHeight;
        if (!!center) style.alignItems = 'center';
        return (
            <Grid pc={1} className={cx(classes.inlineFieldRightAlignChildren, className, 'inlineField')} style={style}>
                {children}
            </Grid>
        );
    }
);

//inline grid with a label on the left. subsequent children appear padded with a left margin
const InlineHeader = withStyles(styles)(({ header, classes, children, className, ...props }) => (
    <Grid pc={1} className={cx(classes.inlineHeader, className, 'inlineField')}>
        <Label text={header} />
        {children}
    </Grid>
));

//inline grid with a label on the left. subsequent children appear right-aligned, padded with a left margin
const InlineHeaderRightAlignChildren = withStyles(styles)(
    ({ header, classes, children, className, disabled, ...props }) => (
        <Grid pc={1} className={cx(classes.inlineHeaderRightAlignChildren, className, 'inlineField')}>
            <Label text={header} disabled={disabled} />
            {children}
        </Grid>
    )
);

const InlineFlex = withStyles(styles)(({ classes, children, style }) => (
    <div className={classes.inlineFlex} style={style}>
        {children}
    </div>
));

export { InlineField, InlineHeader, InlineHeaderRightAlignChildren, InlineFieldRightAlignChildren, InlineFlex };
